// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:32:52

export default {
  "id": "fierce-battle-breakout",
  "slug": "fierce-battle-breakout",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8f3873526b0843a28ce9e3dc6002d1f0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8f3873526b0843a28ce9e3dc6002d1f0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fierce Battle Breakout",
      "description": "This is a fast-paced 3D mini-game that combines survival, combat and strategy. Players will play the role of survivors striving for survival. Facing the threats from enemies, the pursuit of hostile forces and the harsh environment, they will embark on a thrilling journey of survival and defense.\nThe difficulty of the levels will keep increasing. Each level has a large number of enemies constantly swarming towards the players. Players need to eliminate all the enemies to win. ",
      "instructions": "Control the movement of the character through means such as virtual joysticks or touching the screen. For example, manipulate the character to move nimbly and avoid the attacks of enemies. You can also make use of the obstacles and terrain advantages in the game field to formulate strategies and tactics.\nThere are a variety of weapons and equipment available for selection in the game, including firearms, knives and so on. Each weapon has its own characteristics and advantages. ",
      "genres": [
        "Battle",
        "Shooter"
      ],
      "tags": [
        "cartoon",
        "defence",
        "fighting",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "激烈战斗突破",
      "description": "这是一款节奏快速的三维迷你游戏，结合了生存、战斗和策略。玩家将扮演努力求生的幸存者。面对敌人的威胁、敌对势力的追捕和恶劣的环境，他们将踏上惊险的生存与防御之旅。\n关卡难度将逐步提升。每个关卡都有大量敌人不断涌向玩家。玩家需要消灭所有敌人才能获胜。",
      "instructions": "通过虚拟摇杆或触摸屏幕等方式控制角色的移动。例如，操纵角色敏捷移动并避开敌人的攻击。你还可以利用游戏场地的障碍和地形优势制定策略和战术。\n\n游戏中提供了多种可供选择的武器和装备，包括枪械、匕首等。每种武器都有其独特的特性和优势。",
      "genres": [
        "战斗",
        "射击"
      ],
      "tags": [
        "卡通",
        "防御",
        "战斗",
        "射击类"
      ]
    },
    "zh-TW": {
      "title": "瘋狂戰鬥突破",
      "description": "這是一款快節奏的3D迷你遊戲，結合生存、作戰和策略元素。玩家將扮演力求生存的倖存者。面對敵人的威脅、敵對勢力的追擊和嚴酷的自然環境，他們將踏上刺激的生存與防禦之旅。\n關卡難度將不斷上升。每個關卡都有大量敵人持續蜂擁而來。玩家需要消滅所有敵人才能獲勝。",
      "instructions": "控制角色移動，透過虛擬搖桿或觸控螢幕等方式。例如，操縱角色靈巧移動，避開敵人的攻擊。你也可以利用遊戲場景中的障礙和地形優勢，制定策略和戰術。\n\n遊戲中提供多種可供選擇的武器和裝備，包括槍械、刀劍等等。每種武器都有其獨特的特性和優勢。",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "卡通",
        "防禦",
        "格鬥",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "激烈戰鬥突圍",
      "description": "這是一款快節奏的3D迷你遊戲，結合生還、作戰及策略元素。玩家將扮演努力求生的生還者。面對敵人的威脅、敵對勢力的追擊及嚴酷的環境，他們將踏上刺激的生存與防禦之旅。\n關卡難度將逐漸提升。每個關卡都有大量敵人持續蜂擁而來。玩家需要消滅所有敵人才能獲勝。",
      "instructions": "控制角色移動通過虛擬搖桿或觸控螢幕。例如，操縱角色靈活移動並避開敵人的攻擊。你還可以利用遊戲場地的障礙物和地形優勢制定策略和戰術。\n遊戲中提供各種可供選擇的武器和裝備，包括步槍、匕首等等。每種武器都有其獨特的特性和優勢。",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "卡通",
        "防禦",
        "格鬥",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "激しい戦闘勃発",
      "description": "これは、生存、戦闘、戦略を組み合わせたスピーディな3Dミニゲームです。プレイヤーは生存をかけた生存者としてプレイします。敵からの脅威、敵軍の追撃、厳しい環境に直面しながら、彼らは生存と防衛の興奮的な冒険に出かけます。\n\nレベルの難易度は段々と高まります。各レベルには、プレイヤーに向かって常に群がる多数の敵がいます。プレイヤーはすべての敵を排除しなければ勝利できません。",
      "instructions": "キャラクターの動きをバーチャルジョイスティックやスクリーンタッチを使って制御します。例えば、キャラクターを素早く動かして敵の攻撃を避けることができます。ゲームフィールド内の障害物や地形の利点を利用して、戦略や戦術を策定することもできます。\n\nゲームには、銃器、ナイフなど、選択できる様々な武器や装備が用意されています。それぞれの武器には独自の特徴と利点があります。",
      "genres": [
        "バトル",
        "シューター"
      ],
      "tags": [
        "カートゥーン",
        "防衛",
        "ファイト",
        "シューティングアップ"
      ]
    },
    "ko": {
      "title": "용맹한 전투 탈출",
      "description": "이는 생존, 전투, 전략을 결합한 빠른 템포의 3D 미니게임입니다. 플레이어들은 생존을 위해 싸우는 생존자 역할을 맡게 됩니다. 적의 위협, 적대势력의 추격, 가혹한 환경에 직면하여 생존과 방어의 열血한 여정에踏上吧。레벨의 난이도는 계속 증가합니다. 각 레벨에는 플레이어들에게 지속적으로 몰려드는 대량의 적이 있습니다. 플레이어들은 모든 적을 제거하여 승리해야 합니다.",
      "instructions": "캐릭터의 이동을 가상 조이스틱이나 화면을 만지는 방식으로 제어하세요. 예를 들어, 캐릭터를 민첩하게 움직이고 적의 공격을 피하도록 조작하세요. 게임 필드의 장애물과 지형의 이점을 활용하여 전략과 전술을 수립할 수도 있습니다.\n\n게임에서 선택할 수 있는 다양한 무기와 장비가 있습니다. 이에는 소총, 칼 등이 포함됩니다. 각 무기는 자신만의 특성과 장점을 가지고 있습니다.",
      "genres": [
        "전투",
        "쏜사격"
      ],
      "tags": [
        "캐릭톤",
        "방어",
        "싸움",
        "쏘아쏘 게임"
      ]
    },
    "fr": {
      "title": "Débordement de Bataille Féroce",
      "description": "C'est un jeu 3D de mini-jeux rapide qui combine survie, combat et stratégie. Les joueurs joueront le rôle de survivants luttant pour la survie. Face aux menaces des ennemis, à la poursuite des forces hostiles et aux environnements difficiles, ils s'engageront dans un voyage épique de survie et de défense.\nLa difficulté des niveaux augmentera progressivement. Chaque niveau comporte un grand nombre d'ennemis qui envahissent constamment les joueurs. Les joueurs doivent éliminer tous les ennemis pour gagner.",
      "instructions": "Contrôlez le déplacement du personnage à l'aide de moyens tels que les joysticks virtuels ou en touchant l'écran. Par exemple, manipulez le personnage pour qu'il se déplace agilement et évitez les attaques des ennemis. Vous pouvez également utiliser les obstacles et les avantages du terrain sur le champ de jeu pour élaborer des stratégies et des tactiques.\n\nLe jeu propose une variété d'armes et d'équipements disponibles pour le choix, y compris les armes à feu, les couteaux, etc. Chaque arme possède ses propres caractéristiques et avantages.",
      "genres": [
        "Bataille",
        "Tirez"
      ],
      "tags": [
        "dessin animé",
        "défense",
        "combat",
        "tire-l'œil"
      ]
    }
  }
};
